import { Stack, Box, Typography } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';
import { getImgPath } from '../store/JSTool';

export default function TitleView(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);
    const [hideNav, setHideNav] = React.useState(false);

    React.useEffect(() => {
        if (window.innerHeight < 800 && !settingData.isMobile) {
            setHideNav(true);
        }
    }, []);

    return (
        <Stack
            sx={{
                mt: props.mt && props.mt,
                alignItems: 'center',
                zIndex: 2,
                position: 'relative',
                flexDirection: 'row',
                height: '60rem',
                display: hideNav && 'none',
            }}>
            <Stack sx={{
                position: 'absolute',
                flexDirection: 'row',
                height: 1,
                width: 1,
                top: 0,
                left: 0,
                justifyContent: 'center',
                zIndex: 1,
            }}>

                <Box sx={{
                    width: '150rem',
                    background: 'linear-gradient(90deg, #00000000 , #000000cc)',
                }} />
                <Box sx={{
                    flex: 1,
                    background: '#000000cc',
                }} />
                <Box sx={{
                    width: '150rem',
                    background: 'linear-gradient(-90deg, #00000000 , #000000cc)',
                }} />
            </Stack>

            <Box component={'img'}
                src={JSTool.getImgPath('title_left.png')}
                sx={{
                    height: 0.7,
                }} />

            <Typography
                sx={{
                    zIndex: 2,
                    width: 1,
                    height: 1,
                    lineHeight: '60rem',
                    textAlign: 'center',
                    fontSize: props.fontSize ?  props.fontSize : (settingData.isMobile ? '22rem' : '35rem'),
                    color: 'white',
                    fontFamily: window.font0,
                    opacity: 0.9,
                    px: 1.5,
                }}>
                {props.title}
            </Typography>

            <Box component={'img'}
                src={JSTool.getImgPath('title_right.png')}
                sx={{
                    height: 0.7,
                }} />

        </Stack>
    );
}